module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withEdit && !_vm.editOnly) ? [(_vm.displayMode == "view") ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "right": "",
      "absolute": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.displayMode = "edit"
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "right": "",
      "absolute": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.displayMode = "view"
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)] : _vm._e(), _vm._v(" "), (_vm.getRequest.loading) ? _c('tombstone') : [(_vm.displayMode == "view") ? [(_vm.client && _vm.client.client) ? _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_c('h3', {
    staticClass: "subheading ml-3"
  }, [(_vm.client.client.custom_id) ? _c('span', [_vm._v("[" + _vm._s(_vm.client.client.custom_id) + "] ")]) : _vm._e(), _vm._v(" \n          " + _vm._s(_vm.client.client.first_name) + "\n          "), (_vm.client.client.nickname) ? _c('span', [_vm._v(" (" + _vm._s(_vm.client.client.nickname) + ") ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.client.client.last_name) + "\n        ")]), _vm._v(" "), (_vm.client && _vm.client.client) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    },
    on: {
      "click": function($event) {
        return _vm.setMode("edit")
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Email address")]), _vm._v(" "), (_vm.isRealEmail(_vm.client.client.email)) ? _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "mailto:" + _vm.client.client.email
    }
  }, [_vm._v("\n              " + _vm._s(_vm.client.client.email))])]) : _c('v-list-tile-sub-title', [_vm._v("\n              No email address\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.client) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    },
    on: {
      "click": function($event) {
        return _vm.setMode("edit")
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("sms")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Phone number")]), _vm._v(" "), (_vm.client.client.phone_number) ? _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "tel:" + _vm.client.client.phone_number
    }
  }, [_vm._v("\n                " + _vm._s(_vm.client.client.phone_number))])]) : _c('v-list-tile-sub-title', [_vm._v("\n              No phone number\n            ")])], 1), _vm._v(" "), (_vm.client.client) ? _c('v-list-tile-action', [_c('whats-app-btn', {
    attrs: {
      "number": _vm.client.client.phone_number
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()] : [(_vm.client && _vm.client.client) ? _c('client-create', {
    attrs: {
      "relationshipId": _vm.relationshipId,
      "with-header": false,
      "context": _vm.client.context,
      "initial-client": _vm.client.client
    },
    on: {
      "client:updated": _vm.clientUpdated,
      "update:loading": _vm.updateLoading,
      "update:context": function($event) {
        return _vm.$set(_vm.client, "context", $event)
      }
    }
  }) : _vm._e()]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f0b117c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientContactDetails.vue
// module id = 1375
// module chunks = 9